import React from "react";
import StageSteps from "../../components/StageSteps";
import "../../styles/GrowthStage.css";
import BrowseVideos from "../../components/BrowseVideos/BrowseVideos";
import StageVision from "../../components/Vision/StageVision";
import { Stages } from "../../Utils/Stages";
import StageDetails from "../../components/StagesComponents/StageDetails";
import { useNavigate } from "react-router-dom";

const IdeaStageDetails = () => {
  const { helpSteps, ideaStage } = Stages.IdeaStage;
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };
  return (
    <div className="valley-container">
      <div className="valley-innercontainer">
        <div>
          <div style={{width: "auto"}}>
            <h1 className="text-white valley-title">
              Bring Your{" "}
              <span style={{ color: "var(--text-secondary)" }}>Startup Idea</span>{" "}
              To Life
            </h1>
            <div>
              <div>
                <p className="valley-desc">
                  Explore how we help you validate, refine, and plan your startup idea to set the stage for success
                </p>
              </div>
            </div>

            <div className="valley-desktop">
              <div>
                <p
                  style={{ color: "white", paddingTop: "1em" }}
                  className="price-desc"
                >
                  Customised startup consultations starting only at 50K/month
                </p>
              </div>

              <div>
                <button className="valley-btn" onClick={handleGetStarted}>Tell us more...</button>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            className="valley-img"
            src="/ideastage.svg"
            alt="rocket_img"
            height={540}
          />
        </div>
      </div>
      <div className="valley-mobile">
        <div>
          <p
            style={{ color: "white", paddingTop: "1em" }}
            className="price-desc"
          >
            Customised startup consultations starting
            <br />
            only at 50K/month
          </p>
        </div>

        <div>
          <button className="valley-btn" onClick={handleGetStarted}>Tell us more...</button>
          <br />
        </div>
      </div>
      {/* WHAT IS VALLEY */}
      <div className="what-is-valley">
        <div style={{ width: "90%", margin: "auto" }}>
          <p className="what-is-valley-title" style={{ textAlign: "center" }}>
            What Is The
            <span style={{ color: "var(--text-secondary)" }}> Idea Stage?</span>
          </p>
        </div>
        <div style={{ width: "90%", margin: "auto" }}>
          <p className="what-is-valley-desc">
            The Idea Stage is the foundation of every great startup. It’s where
            you identify a problem,
            <br className="valley-desktop" />
            conceptualize a solution, & validate its potential. Whether you’re a
            first-time founder or refining a new
            <br className="valley-desktop" />
            concept, this stage is all about turning your dream into a viable
            plan.
          </p>
        </div>
        {/* IMAGE AND INFO */}
        <div className="valley-left-right-container">
          <div className="valley-left">
            <img
              src="/ideastage2.svg"
              className="valley-img"
              alt="valley_image"
            />
          </div>
          <div id="valley-right">
            {ideaStage.map((stage, index) => (
              <StageDetails key={index} stage={stage} />
            ))}
          </div>
        </div>
      </div>
      <StageSteps
        title={"How We Can Help You In The Idea Stage ?"}
        helpSteps={helpSteps}
      />
      <div style={{ textAlign: "center" }}>
        <BrowseVideos backgroundType="black" />
      </div>
      <div style={{ textAlign: "center" }}>
        <StageVision />
      </div>
    </div>
  );
};

export default IdeaStageDetails;
